import { createSignal } from '@verclam/pulsar';

/**
 * Location key of the navigation on which the settings panel was opened over the page, or `null`. A
 * location key is unique per navigation, even towards the current URL: any navigation outdates the value,
 * so the panel closes without a synchronisation effect.
 */
const settingsPanelSignal = createSignal<string | null>(null);

export const openSettingsPanelAt = (locationKey: string): void => {
	settingsPanelSignal.value = locationKey;
};

export const closeSettingsPanel = (): void => {
	settingsPanelSignal.value = null;
};

export default settingsPanelSignal;
